<template>
    <div style="display: inline-block;">
        <span
            class="Disp_AC SysFontM fs18"
            style="cursor: pointer;height:100%"
            :style="{
                color,
            }"
            @click="$emit('click')">
            <cl-svg-icon width="20" :currentColor="false" :icon-class="icon"></cl-svg-icon>
            <slot></slot>
        </span>
    </div>
</template>

<script>
/**
 * ComponentName: 页面返回组件
 * Created Date:2022/4/24
 * Author: Nancy
 * Modify: dongyu·zhu zhangch 2022/4/27 | shishuo·zhang 2022/4/28
 * Modify: zhangjun 外层套inline-block，防止点击空白区域跳转。
 * 组件说明：
 * 这个组件是页面顶部返回功能。
 * eg:
 *     <cl-page-back @click="back">返回</cl-page-back>
 */
export default {
    name: 'cl-page-back',
    data () {
        return {

        };
    },
    props: {
        icon: {
            type: String,
            default: 'page_back'
        },
        color: {
            type: String,
            default: '#000'
        }
    },
}
</script>
<style lang='scss' scoped>
</style>